<!-- Just add class "container" for CultureQuestion next to the class "main-breadcrumb" -->
@if (breadcrumbs?.length) {
  <nav
    id="breadcrumb"
    aria-label="breadcrumb"
    class="main-breadcrumb"
    [ngClass]="{'container': breadcrumbFixedWidth}"
    >
    <!-- <h1 *ngIf="pageTitle; else preventsJumpiness" class="page-title">
    {{pageTitle}}
    </h1><ng-template #preventsJumpiness><h1 class="opacity-0">|</h1></ng-template> -->
    <h1 class="page-title" *transloco="let t">
      @if (pageTitle) {
        <span>{{pageTitle}}</span>
      }
      @if (!pageTitle && pageTitleTranslationKey) {
        <span *transloco="let scopedT; scope: pageTitleTranslationScope ?? undefined">{{scopedT(pageTitleTranslationKey)}}</span>
      }
      @if (!pageTitle && !pageTitleTranslationKey) {
        <span class="opacity-0">...</span>
      }
    </h1>
    <!-- DEBUGGING: <ul><li *ngFor="let b of breadcrumbs">{{b | json}}</li></ul> -->
    <ol class="breadcrumb" *transloco="let t">
      @if (breadcrumbs?.length) {
        <li class="breadcrumb-item"><a [routerLink]="['/']">
          <span>{{t('common.home')}}</span>
          <!-- <i class="fa-solid fa-house"></i> -->
        </a></li>
      }
      @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
        <li class="breadcrumb-item">
          @if (i === breadcrumbs.length-1 ) {
            <span *transloco="let scopedT; scope: breadcrumb.translationScope ?? undefined">{{
              breadcrumb.labelSource === 'titleService'
              ? pageTitle : breadcrumb.translationKey
              ? scopedT(breadcrumb.translationKey)
              :  breadcrumb.translationKey
              ? scopedT(breadcrumb.translationKey)
              : breadcrumb.label
            }}</span>
          } @else {
            <a
              [routerLink]="breadcrumb.url"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              >
              <span *transloco="let scopedT; scope: breadcrumb.translationScope ?? undefined">{{
                breadcrumb.labelSource === 'titleService'
                ? breadcrumb?.paramName && getFragmentName(breadcrumb.paramName) : getFragmentName(breadcrumb.paramName)
                ? scopedT(breadcrumb.translationKey)
                : breadcrumb.translationKey
                ? scopedT(breadcrumb.translationKey) : breadcrumb.label
              }}</span>
            </a>
          }
        </li>
      }
    </ol>
    <!-- <div>
    <p *ngFor="let breadcrumb of breadcrumbs">source:{{breadcrumb.labelSource}} | label: {{breadcrumb.label}} | key: {{breadcrumb.translationKey}}<br>-----------------</p>
  </div> -->
</nav>
}
